/**
 * Once the picture is in, the fight holds this long: the two names, what the square's light gives
 * each, and a count of three (x-aaa-gap#3). Online the server holds as well: it starts the duel
 * when each person's first input arrives, and none goes out before the count ends.
 */
export const INTRO_HOLD_SECONDS = 1.5;
/** "Fight!" stays up this long once the fight begins. */
export const FIGHT_CALL_SECONDS = 0.6;

/** The count of three over the hold: 3, 2, 1, then 0 for "Fight!" and `null` after it. */
export function introCount(msToFight: number, msSinceFight = -1): number | null {
  if (msToFight > 0)
    return Math.min(3, Math.max(1, Math.ceil((msToFight / (INTRO_HOLD_SECONDS * 1000)) * 3)));
  return msSinceFight >= 0 && msSinceFight < FIGHT_CALL_SECONDS * 1000 ? 0 : null;
}
